module.exports = __webpack_public_path__ + "static/media/arrow.475e8ebe.svg";